import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  authToken: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    updateAuthToken: (state, action) => {
      state.authToken = action.payload;
    },
  },
});

export default authSlice.reducer;
export const { updateAuthToken } = authSlice.actions;
